import { useState } from "react";

type Props = {
    state: string;
    setState: (value: string) => void;
    zip: string;
    setZip: (value: string) => void;
}

export const TextSettings = ({ state, setState, zip, setZip }: Props) => {
    const [disabled, setDisabled] = useState<boolean>(true);

    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className="w-full bg-white p-4 rounded-md">
                <div className="w-full mt-2">
                    <div className={`w-full pb-4`}>
                        <div className={`flex justify-between items-center p-2 border-b border-secondary`}>
                            <div className="flex items-center gap-1.5">
                                <h2 className={`text-lg font-semibold text-secondary`}>Text Settings</h2>
                            </div>

                            {
                                disabled && (
                                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border border-secondary text-white flex items-center gap-1.5`}
                                        onClick={() => setDisabled(false)}
                                    >
                                        <span className={`material-symbols-outlined text-[25px] font-light text-secondary`}>
                                            edit
                                        </span>
                                        <span className={`text-xs font-medium text-secondary`}>Edit</span>
                                    </button>
                                )
                            }
                        </div>

                        <div className="grid grid-cols-3 gap-6">
                            <div className="space-y-4">
                                <div>
                                    <label className={`text-xs font-medium text-secondary`}>State</label>
                                    <input
                                        type="text"
                                        className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                        value={state}
                                        onChange={(e) =>
                                            setState(e.target.value)
                                        }
                                        disabled={disabled}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className={`text-xs font-medium text-secondary`}>Zip</label>
                                    <input
                                        type="text"
                                        className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                        value={zip}
                                        onChange={(e) =>
                                            setZip(e.target.value)
                                        }
                                        disabled={disabled}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
